import applogger from '@applogger'
let pageMixin
let asyncLoader

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  asyncLoader = function({ store, route }, edit = false) {
    applogger.debug('page-content-type-news asyncData starting')
    let obj = {path: route.fullPath}
    if (edit) {
      obj = {id: route.params.itemid}
    }
    return store.dispatch('item/load', obj)
      .then(node => {
        let loaders = []
        loaders.push(store.dispatch('blob/load', {blobID: `page-blob-top--node-${node.nid}`}))
        loaders.push(store.dispatch('blob/load', {blobID: `page-blob-bottom--node-${node.nid}`}))
        return Promise.all([node, Promise.all(loaders)])
      })
      .then(([node, loaders]) => {
        applogger.debug('page-content-type-news asyncData Complete')
        return {
          itemid: node.nid,
          title: node.title
        }
      })
  }

  pageMixin = {
    mounted: function() {
      this.formData = JSON.parse(JSON.stringify(this.item))
    },

    computed: {
      itemid() {
        return this.item.id
      },
      item() {
        let item
        if (this.$route.path) {
          item = this.$store.getters['item/getByPath'](this.$route.path)
        }
        else {
          item = this.$store.getters['item/getByid'](this.$route.params.itemid)
        }
        return (item) || {name: '', id: '', body: ''}
      },
      notpublished() {
        return !this.item.published
      },
      title() {
        return this.item.name
      },
      content() {
        return this.item.body
      },
      category() {
        return this.$store.getters['config/getTermLabelFromEnum'](this.item.category)
      }
    }
  }
}
else {
  asyncLoader = function({ store, route, router }) {
    if (!route) {
      return Promise.resolve(false)
    }
    applogger.debug('page-content-type-faq asyncData starting')
    return store.dispatch('node/load', {nid: route.path, cacheOptions: {scope: 'global'}})
      .then(node => {
        let loaders = [
          Promise.resolve(node)
        ]
        loaders.push(store.dispatch('blob/load', {blobID: `page-blob-top--node-${node.nid}`}))
        loaders.push(store.dispatch('blob/load', {blobID: `page-blob-bottom--node-${node.nid}`}))

        return Promise.all(loaders)
      })
      .then(([node, loaders]) => {
        applogger.debug('page-content-type-faq asyncData Complete')
        return {
          itemid: node.nid,
          title: node.title
        }
      })
      .catch(err => {
        applogger.error('An error occurred loading the page.')
        switch (err.response.status) {
        case 403:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
          break
        case 404:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          break
        default:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
          break
        }
      })
  }

  pageMixin = {
    created() {
      this.$eventHub.$on('loginComplete', this.onLoginComplete)
      this.item = this.$store.getters['node/getByPath'](this.$route.path)
    },
    methods: {
      onLoginComplete: function() {
        asyncLoader({store: this.$store, route: this.$route, router: this.$router})
      }
    },
    data: function() {
      return {
        item: null
      }
    },
    computed: {
      itemid() {
        return this.item ? this.item.nid : ''
      },
      notpublished() {
        return (!this.$store.getters['node/published'](this.itemid))
      },
      title() {
        return this.item.title
      },
      content() {
        return this.item.body
      },
      category() {
        return this.$store.getters['config/getTermLabelFromEnum'](this.item.field_x_faq_category)
      }
    }
  }
}

export default pageMixin
export {
  pageMixin,
  asyncLoader
}
